function highlightSelectedOffers() {
    var checkedLinks = document.querySelectorAll('.sk-uigroup--offers .sk-checkbox input:checked');
    checkedLinks.forEach(item => {
        item.closest(".sk-uigroup-item").classList.add("sk-uigroup-item--selected");
    })

    var links = document.querySelectorAll('.sk-uigroup--offers .sk-checkbox input');
    links.forEach(item => {
        item.addEventListener("change", () => {
            item.closest(".sk-uigroup-item").classList.toggle("sk-uigroup-item--selected");
        });
    });
}

export { highlightSelectedOffers };